import React from 'react';
import { useStringsContext } from '../../../../../contexts/strings';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import svStrings from '../../../../../sv-strings';
import * as yup from 'yup';
import { Poll, PollKeys } from '../../types';
import PollCard from '../poll-card';
import { InputWithValidateProps } from '../../../../common/input/text-input-with-validate';
import ImageWithValidate from '../../../../common/input/image-with-validate';

const LOGO_RECOMMENDED_HEIGHT = 960;
const LOGO_RECOMMENDED_WIDTH = 540;

const backgroundImageKey: PollKeys = 'backgroundImage';
const sponsorImageKey: PollKeys = 'sponsorImage';

interface Props extends InputWithValidateProps {
  pollId: string;
  selectedPoll: Poll | null;
  titleBackgroundImage: string;
}

const PollImagesCard = ({
  pollId,
  selectedPoll,
  titleBackgroundImage,
  onValue,
  onValidation,
  hideValidationError,
}: Props) => {
  const { strings } = useStringsContext();

  return (
    <PollCard title={strings.polls.pollImageUploads}>
      <Box>
        <Stack>
          <Typography variant="body2-bold">{titleBackgroundImage}</Typography>
          <Typography variant="caption" color="textSecondary">
            {strings.polls.backgroundImageLabel}
          </Typography>
        </Stack>
        <ImageWithValidate
          name={backgroundImageKey}
          storagePath={`pollImages/${pollId}`}
          onValue={onValue}
          onValidation={onValidation}
          value={selectedPoll?.backgroundImage || ''}
          hideValidationError={hideValidationError}
          validation={yup.string().url(svStrings.validations.validImage).nullable(true)}
          recommendedHeight={LOGO_RECOMMENDED_HEIGHT}
          recommendedWidth={LOGO_RECOMMENDED_WIDTH}
        />
      </Box>
      <Box>
        <Stack>
          <Typography variant="body2-bold">{strings.polls.sponsorImageTitle}</Typography>
          <Typography variant="caption" color="textSecondary">
            {strings.polls.sponsorImageLabel}
          </Typography>
        </Stack>
        <ImageWithValidate
          name={sponsorImageKey}
          storagePath={`pollImages/${pollId}`}
          onValue={onValue}
          onValidation={onValidation}
          value={selectedPoll?.sponsorImage || ''}
          hideValidationError={hideValidationError}
          validation={yup.string().url(svStrings.validations.validImage).nullable(true)}
        />
      </Box>
    </PollCard>
  );
};

export default PollImagesCard;
